import { Stack } from "@mui/material";
import type { FC } from "react";
import type { ClientPropertyArtDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { PropertyPurchaseDetails } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/PropertyPurchaseDetails";

const PageResources = Resources.PortfolioDetail;

type Props = {
	data: ClientPropertyArtDetailResponseDTO;
	currencySign: string;
};

export const ArtRedesign: FC<Props> = ({ data }) => {
	const { t } = useResource();

	return (
		<>
			<Stack bgcolor="background.paper">
				<DetailRow
					label={t(PageResources.Property.ItemTitle)}
					value={data.propertyType}
				/>
				<DetailRow
					label={t(PageResources.Property.ArtName)}
					value={data.customDisposition}
				/>
			</Stack>

			<PropertyPurchaseDetails
				purchaseDate={data.purchaseDate}
				description={data.description}
			/>
		</>
	);
};
